import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import shoppingCartState from '../state/checkout/shopping-cart-state.js';
export const useShoppingCartClear = () => {
    const setShoppingCartRequest = useSetRecoilState(shoppingCartState.request);
    const setShoppingCartStale = useSetRecoilState(shoppingCartState.stale);
    const clearCart = useCallback(async () => {
        // Unset the current shopping cart order id and mark it stale to ensure an update
        //
        setShoppingCartRequest({
            OrderID: 0,
        });
        setShoppingCartStale(`${new Date().valueOf()}`);
    }, []);
    return clearCart;
};
export default useShoppingCartClear;
//# sourceMappingURL=use-shopping-cart-clear.js.map